<script lang="ts" module>
  import Pagination, { type PaginationProps } from '@/ui/elements/pagination/Pagination.svelte';

  import ImpactTpi, { type ImpactTPIProps } from './ImpactTPI.svelte';

  export type AIContentHeaderProps = Omit<ImpactTPIProps, 'tpi'> & {
    tpi?: number;
  } & PaginationProps;
</script>

<script lang="ts">
  let {
    tpi,
    pages,
    current: currentProp = $bindable(),
    onPageChange,
  }: AIContentHeaderProps = $props();
</script>

<div class="flex justify-between">
  {#if typeof tpi !== 'undefined'}
    <ImpactTpi {tpi}></ImpactTpi>
  {:else}
    <div></div>
  {/if}
  {#if pages > 1}
    <Pagination {pages} bind:current={currentProp} {onPageChange}></Pagination>
  {/if}
</div>
